import sensoryTemplate from "@/components/common/i18n/sensory/sensoryTemplate";
import sensoryReport from "@/components/common/i18n/sensory/sensoryReport";
import sensoryCalibration from "@/components/common/i18n/sensory/sensoryCalibration";
import sensoryProcess from "@/components/common/i18n/sensory/sensoryProcess";

export default {
    zh: {
        title: 'Sensory',
        template: sensoryTemplate.zh,
        report: sensoryReport.zh,
        calibration: sensoryCalibration.zh,
        process: {
            report: sensoryProcess.zh
        }
    },
    en: {
        title: 'Sensory',
        template: sensoryTemplate.en,
        report: sensoryReport.en,
        calibration: sensoryCalibration.en,
        process: {
            report: sensoryProcess.en
        }
    }
}